export default "__VITE_ASSET__e5d8c626__"